import { useState, useCallback, useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { baseUrl } from "components/shared/apiCrudBuilder";

const API_URL = baseUrl + "/ask-gemini";

/**
 * Custom React hook to interact with the AskOpenAiView API.
 * @returns {Object} - { askOpenAI, loading, error, response }
 */
export function useAI() {
  const { appAxiosRingback } = useContext(AuthenticationContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const askOpenAI = useCallback(async (data) => {
    setLoading(true);
    setError(null);
    try {
      const res = await appAxiosRingback.post(API_URL, data);
      return res.data;
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { askOpenAI, loading, error };
}
